import {link} from '../../../common';
import * as s from './Accordion.scss';
import {$$} from '../../../../utils';

const AccordionDataHook = 'wix-footer-accordion-button';

const AccordionItem = item => {
  return `
    <div class="${s.wrapper}">
      <button class="${s.button}" aria-expanded="false" data-expanded="false" data-hook="${AccordionDataHook}">${item.text}</button>
      <ul class="${s.panel}" ${item.name ? `data-bi-name="${item.name}"` : ''}>
          ${item.subs.map(item => link(item, {}, null, null, null, null, null)).join('')}
      </ul>
    </div>
`;
};

const Accordion = list => {
  return list.map(item => AccordionItem(item)).join('');
};

function toggleAccordionItem(item) {
  const isExpanded = item.getAttribute('data-expanded') === 'false';
  item.setAttribute('aria-expanded', isExpanded.toString());
  item.setAttribute('data-expanded', isExpanded.toString());
}


export function bindAccordionClickListeners() {
  $$(`[data-hook=${AccordionDataHook}]`).forEach(button => {
    button.addEventListener('click', () => {
      toggleAccordionItem(button);
    });
  });
}

export default Accordion;
